import { useEffect, useState } from 'react'

// Matches a media query after mount. Always false on the server and the first client render,
// so layout that depends on it never causes a hydration mismatch.
export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        const media = window.matchMedia(query)
        const update = () => setMatches(media.matches)

        update()
        media.addEventListener('change', update)

        return () => media.removeEventListener('change', update)
    }, [query])

    return matches
}
